<div class="wrapper">

  <div class="cuerpo">
    <h1 class="tp-navandu line-navandu">GENERACIÓN DE DOCUMENTO</h1>
    <form name="entrar" [formGroup]="documentForm" (ngSubmit)="onSubmit()" class="formulario" autocomplete="off">
      <div class="row documento">

        <div class="switch-button">
          <label class="varios-firmantes">¿Enviar a varios firmantes?</label>
          <input type="checkbox" name="switch-button" id="switch-label" class="switch-button__checkbox"
            (click)="checkSeveralSigner($event)">
          <label for="switch-label" class="switch-button__label"></label>
          <label class="varios-firmantes">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;¿Enviar copia documento firmado
            (destinatario)?</label>
          <input type="checkbox" name="switch-button" id="switch-label2" class="switch-button__checkbox"
            (click)="checkSendEmail($event)">
          <label for="switch-label2" class="switch-button__label"></label>
          <label class="varios-firmantes">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;¿Enviar alerta documento firmado
            (usuario)?</label>
          <input type="checkbox" name="switch-button" id="switch-label4" class="switch-button__checkbox"
            (click)="checkSendEmailToCreator($event)" checked="true">
          <label for="switch-label4" class="switch-button__label"></label>
          <div class="tooltip4">
            @if (!severalSigners && countSigners > 0) {
            <label class="varios-firmantes">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;¿Enviar firmas ordenadas?
            </label>

            <input type="checkbox" name="switch-button" id="switch-label3" class="switch-button__checkbox"
              (click)="checkOrderedSignatures($event)" checked="true">

            <label for="switch-label3" class="switch-button__label"></label>
            }

            <span class="tooltiptext4">
              Firmas ordenadas por el orden de destinatarios o poder firmar libremente
            </span>
          </div>
        </div>

        <div class="listado-firmantes" [hidden]="!severalSigners">
          <h2>LISTADO DE FIRMANTES PARA ENVIAR DOCUMENTO</h2>
          <div class="input-field col s12 buscador">

            <input id="filter" type="text" (keyup)="applyFilter($event)">
            <label for="filter" data-error="Ingrese un dato valido" data-success=""> <i
                class="material-icons">search</i></label>
          </div>

          <table mat-table [dataSource]="dataSource" class="tabla">

            <!-- check Column -->
            <ng-container matColumnDef="check">
              <th mat-header-cell *matHeaderCellDef> Acción </th>
              <td mat-cell *matCellDef="let element">
                <input type="checkbox" name="switch-button" id="switch-label" class="switch-button__checkbox"
                  (click)="checkSignser($event, element)" [checked]="element.checked">
              </td>
            </ng-container>

            <!-- Position Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> Nombre</th>
              <td mat-cell *matCellDef="let element"> {{element.name + " " + element.lastName}}</td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="idn">
              <th mat-header-cell *matHeaderCellDef> Documento </th>
              <td mat-cell *matCellDef="let element"> {{element.idn}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef> Correo </th>
              <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef> Teléfono </th>
              <td mat-cell *matCellDef="let element"> {{element.phone}} </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>

        </div>

        @if (!severalSigners) {
        <div class="info-destinatario">
          <h2 class="tp-navandu"> INFORMACIÓN DEL DESTINATARIO </h2>
          <div class="flex-row">
            <mat-form-field class="example-full-width">
              <mat-label>Número de documento</mat-label>
              <input type="text" matInput formControlName="addressee_document" required [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete">
                @for (option of filteredOptions | async; track option) {
                <mat-option [value]="option.idn">
                  {{option.idn}}
                </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Tipo de documento</mat-label>
              <mat-select required formControlName="addressee_document_type">
                <mat-option value="Alias">Alias</mat-option>
                <mat-option value="DNI">DNI</mat-option>
                <mat-option value="NIF">NIF</mat-option>
                <mat-option value="NIE">NIE</mat-option>
                <mat-option value="CIF">CIF</mat-option>
                <mat-option value="PASS">PASS</mat-option>
                <mat-option value="RUC">RUC</mat-option>
                <mat-option value="Cedula">Cedula</mat-option>
                <mat-option value="Otro">Otro</mat-option>
              </mat-select>
              @if (documentForm.controls.addressee_document_type.hasError('required')) {
              <mat-error>
                Tipo de documento <strong>requerido</strong>
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="flex-row">
            <mat-form-field class="example-full-width">
              <mat-label>Nombre</mat-label>
              <input type="text" matInput formControlName="addressee_name" required [matAutocomplete]="autoName">
              <mat-autocomplete #autoName="matAutocomplete">
                @for (option of filteredOptionsName | async; track option) {
                <mat-option [value]="option.name">
                  {{option.name}}
                </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Apellidos</mat-label>
              <input type="text" matInput formControlName="addressee_last_name" required
                [matAutocomplete]="autoLastName">
              <mat-autocomplete #autoLastName="matAutocomplete">
                @for (option of filteredOptionsLastName | async; track option) {
                <mat-option [value]="option.lastName">
                  {{option.lastName}}
                </mat-option>
                }
              </mat-autocomplete>
              @if (documentForm.controls.addressee_last_name.hasError('required')) {
              <mat-error>
                Apellido <strong>requerido</strong>
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="flex-row filatres">
            <div class="phone-group">
              <mat-form-field class="prefix-section">
                <mat-select required formControlName="addressee_country">
                  @for (phonePrefix of phonePrefixes; track phonePrefix) {
                  <mat-option [value]="phonePrefix.prefix">
                    {{phonePrefix.code}}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="phone">
                <mat-label>Móvil para sms de firma</mat-label>
                <input matInput formControlName="addressee_phone"
                  [required]="documentForm.controls.addressee_phone.hasError('required')">
                @if (documentForm.controls.addressee_phone.hasError('required')) {
                <mat-error>
                  Móvil <strong>requerido</strong>
                </mat-error>
                }
                @if (documentForm.controls.addressee_phone.hasError('minlength') ||
                documentForm.controls.addressee_phone.hasError('maxlength')) {
                <mat-error>
                  Móvil <strong>debe tener 9 caracteres</strong>
                </mat-error>
                }
                @if (documentForm.controls.addressee_phone.hasError('pattern')) {
                <mat-error>
                  Móvil <strong>debe ser numérico</strong>
                </mat-error>
                }
                @if (documentForm.controls.addressee_phone.hasError('invalidNumber')) {
                <mat-error>
                  Móvil <strong>no valido</strong>
                </mat-error>
                }
              </mat-form-field>
            </div>
            <mat-form-field class="email">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Ex. pat@example.com" formControlName="addressee_mail"
                [required]="documentForm.controls.addressee_mail.hasError('required')">
              @if (documentForm.controls.addressee_mail.hasError('email') &&
              !documentForm.controls.addressee_mail.hasError('required')) {
              <mat-error>
                Por favor ingrese un correo válido
              </mat-error>
              }
              @if (documentForm.controls.addressee_mail.hasError('required')) {
              <mat-error>
                Correo <strong>requerido</strong>
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="flex-row">
            <mat-form-field>
              <mat-label>Nº Expediente</mat-label>
              <input matInput formControlName="expedient">
            </mat-form-field>
          </div>
          <div class="tooltip2 iconomas">
            <a class="tp-navandu" (click)="addSigner()">
              <mat-icon>add_circle</mat-icon>
            </a>
            <span class="tooltiptext2">Añadir firmante</span>
          </div>
        </div>
        }
      </div>

      @for (signer of getSigners()['controls']; track signer; let j = $index; let last = $last; let first = $first) {
      <div formArrayName="signers" class="info-destinatario">
        <div class="row documento">
          <div [formGroupName]="j">
            @if (documentForm.controls.addresseeAsSigner.value) {
            <h2 class="tp-navandu"> INFORMACIÓN
              DEL FIRMANTE {{j + 2}}</h2>
            } @else {
            <h2 class="tp-navandu"> INFORMACIÓN DEL FIRMANTE {{j + 1}}</h2>
            }
            <div class="flex-row">
              <mat-form-field class="example-full-width">
                <mat-label>Número de documento</mat-label>
                <input type="text" matInput formControlName="signer_document" required [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete">
                  @for (option of filterOptionsSigners[j] | async; track option) {
                  <mat-option [value]="option.idn">
                    {{option.idn}}
                  </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Tipo de documento</mat-label>
                <mat-select required formControlName="signer_documet_type">
                  <mat-option value="Alias">Alias</mat-option>
                  <mat-option value="DNI">DNI</mat-option>
                  <mat-option value="NIF">NIF</mat-option>
                  <mat-option value="NIE">NIE</mat-option>
                  <mat-option value="CIF">CIF</mat-option>
                  <mat-option value="PASS">PASS</mat-option>
                  <mat-option value="RUC">RUC</mat-option>
                  <mat-option value="Cedula">Cedula</mat-option>
                  <mat-option value="Otro">Otro</mat-option>
                </mat-select>
                @if (signer.controls.signer_documet_type.hasError('required')) {
                <mat-error>
                  Tipo de documento <strong>requerido</strong>
                </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row">
              <mat-form-field>
                <mat-label>Nombre</mat-label>
                <input matInput formControlName="signer_name" required>
                @if (signer.controls.signer_name.hasError('required')) {
                <mat-error>
                  Nombre <strong>requerido</strong>
                </mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Apellidos</mat-label>
                <input matInput formControlName="signer_last_name" required>
                @if (signer.controls.signer_last_name.hasError('required')) {
                <mat-error>
                  Apellido <strong>requerido</strong>
                </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row filatres">
              <div class="phone-group">
                <mat-form-field class="prefix-section">
                  <mat-select required formControlName="addressee_country">
                    @for (phonePrefix of phonePrefixes; track phonePrefix) {
                    <mat-option [value]="phonePrefix.prefix">
                      {{phonePrefix.code}}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="phone">
                  <mat-label>Móvil para sms de firma</mat-label>
                  <input matInput formControlName="signer_phone"
                    [required]="signer.controls.signer_phone.hasError('required')">
                  @if (signer.controls.signer_phone.hasError('required')) {
                  <mat-error>
                    Móvil <strong>requerido</strong>
                  </mat-error>
                  }
                  @if (signer.controls.signer_phone.hasError('minlength') ||
                  signer.controls.signer_phone.hasError('maxlength')) {
                  <mat-error>
                    Móvil <strong>debe tener 9 caracteres</strong>
                  </mat-error>
                  }
                  @if (signer.controls.signer_phone.hasError('pattern')) {
                  <mat-error>
                    Móvil <strong>debe ser numérico</strong>
                  </mat-error>
                  }
                  @if (signer.controls.signer_phone.hasError('invalidNumber')) {
                  <mat-error>
                    Móvil <strong>no valido</strong>
                  </mat-error>
                  }
                </mat-form-field>
              </div>
              <mat-form-field class="email">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Ex. pat@example.com" formControlName="signer_mail"
                  [required]="signer.controls.signer_mail.hasError('required')">
                @if (signer.controls.signer_mail.hasError('email') && !signer.controls.signer_mail.hasError('required'))
                {
                <mat-error>
                  Por favor ingrese un correo válido
                </mat-error>
                }
                @if (signer.controls.signer_mail.hasError('required')) {
                <mat-error>
                  Correo <strong>requerido</strong>
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="masmenos">
            <div class="tooltip2 iconomenos">
              <a class="tp-navandu" (click)="removeSigner(j)">
                <mat-icon>remove_circle</mat-icon>
              </a>
              <span class="tooltiptext2">Quitar firmante</span>
            </div>
            <div>
              <div class="tooltip2 iconomas">
                <a class="tp-navandu" (click)="addSigner()">
                  <mat-icon>add_circle</mat-icon>
                </a>
                <span class="tooltiptext2">Añadir firmante</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      }

      <div class="row documento">
        <div class="info-destinatario">
          <div class="flex-row">
            <mat-form-field>
              <mat-label>Tipo de firma</mat-label>
              <mat-select required formControlName="signatureType" (selectionChange)="select($event.value)">
                @for (chanel of signatureChanels; track chanel) {
                <mat-option [value]="chanel.id">
                  {{chanel.name}}
                </mat-option>
                }
              </mat-select>
              @if (documentForm.controls.signatureType.hasError('required')) {
              <mat-error>
                Tipo de firma <strong>requerido</strong>
              </mat-error>
              }
            </mat-form-field>
            @if (documentForm.controls['signatureType'].value == '2') {
            <mat-form-field>
              <mat-label>Dispositivo</mat-label>
              <mat-select formControlName="device" required>
                @for (device of devices; track device) {
                <mat-option [value]="device.deviceName">
                  {{device.deviceDescription}}
                </mat-option>
                }
              </mat-select>
              @if (documentForm.controls.device.hasError('required')) {
              <mat-error>
                Dispositivo <strong>requerido</strong>
              </mat-error>
              }
            </mat-form-field>
            }
          </div>
        </div>
      </div>

      <div class="documento sign">
        <mat-form-field>
          <div>
            <mat-toolbar>
              <input matInput [(ngModel)]="fileAttr" readonly name="name" [ngModelOptions]="{standalone: true}" />
              <input type="button" mat-flat-button color="primary" class="boton-up" value="Subir archivo">
            </mat-toolbar>

            <input type="file" #fileInput id="uploadFile" (change)="converter($event)" name="uploadFile"
              accept="application/pdf" />
            @if (reader.readyState == 1) {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            }
          </div>
        </mat-form-field>

        @if (doneImageConvert==='loading') {
        <app-spinner></app-spinner>
        }
        @if (doneImageConvert === 'loading') {
        <app-spinner></app-spinner>
        } @else if (doneImageConvert === 'done') {
        <div>
          @if (!loading) {
          <div class="select-state">
            <button mat-icon-button class="refrescar" (click)="changePage('previus')" type="button">
              <div class="tooltip3">
                <mat-icon>chevron_left</mat-icon>
                <span class="tooltiptext3">Anterior</span>
              </div>
            </button>

            <p>Página: {{ pageImagePdf + 1 }} de {{ lengthPageImagePdf }}</p>

            <button mat-icon-button class="refrescar" (click)="changePage('next')" type="button">
              <div class="tooltip3">
                <mat-icon>chevron_right</mat-icon>
                <span class="tooltiptext3">Siguiente</span>
              </div>
            </button>
          </div>
          }

          <div class="example-boundary" [style.backgroundImage]="'url(' + imagepdf + ')'">
            <div class="element example-box" cdkDragBoundary=".example-boundary" cdkDrag
              (cdkDragEnded)="dragEnd($event, 0)" id="coordinate" (click)="displayContextMenu($event, 0)"
              [cdkDragDisabled]="isDisplayContextMenu[0].locked">
              Firma 1
              @if (isDisplayContextMenu[0].visible) {
              <app-context-menu [ngStyle]="getRightClickMenuStyle()" [contextMenuItems]="rightClickMenuItems"
                (onContextMenuItemClick)="handleMenuItemClick($event, 0)">
              </app-context-menu>
              }
            </div>
            @for (firmante of arraySigners; track firmante; let i = $index) {
            <div>
              <div class="element example-box" cdkDragBoundary=".example-boundary" cdkDrag
                [cdkDragFreeDragPosition]="firmante" (cdkDragEnded)="dragEnd($event, i+1)" id="coordinate[{{i}}]"
                (click)="displayContextMenu($event, i+1)" [cdkDragDisabled]="isDisplayContextMenu[i+1].locked">Firma {{i
                +2}}
                @if (isDisplayContextMenu[i+1].visible) {
                <app-context-menu [ngStyle]="getRightClickMenuStyle()" [contextMenuItems]="rightClickMenuItems"
                  (onContextMenuItemClick)="handleMenuItemClick($event, i+1)">
                </app-context-menu>
                }
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>

      <div class="enviar">
        <input type="submit" class="boton" value="Enviar" [disabled]="buttonDisable">
      </div>

      <a routerLink="/templates" class="volver"><span>Volver</span> </a>
    </form>
  </div>
</div>